import { Card, Col, PageHeader, Row, Tag } from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import React, { Component } from "react";

const OPCIONES = [
  {
    key: "realizada",
    titulo: "Cobranza Realizada",
    descripcion:
      "Consulta el dinero que ya cobraste, semana por semana, con base en los pagos registrados.",
    icono: <CheckCircleOutlined />,
    color: "#52c41a",
    ruta: "realizada",
    disabled: false,
  },
  {
    key: "proyectada",
    titulo: "Cobranza Proyectada",
    descripcion:
      "Estima cuánto deberías cobrar en las próximas semanas según las fechas de vencimiento de tus facturas, incluyendo lo que ya está vencido.",
    icono: <ClockCircleOutlined />,
    color: "#1890ff",
    ruta: "proyectada",
    disabled: false,
  },
  {
    key: "comparativo",
    titulo: "Proyectado vs Real",
    descripcion:
      "Compara lo que proyectaste cobrar contra lo que realmente cobraste.",
    icono: <SwapOutlined />,
    color: "#722ed1",
    ruta: "comparativo",
    disabled: false,
  },
];

class ReporteCobranzaPorSemana extends Component {
  atras() {
    this.props.history.goBack();
  }

  seleccionar(opcion) {
    if (opcion.disabled) return;
    this.props.history.push(`${this.props.match.url}/${opcion.ruta}`);
  }

  render() {
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Cobranza"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <Row gutter={16}>
          {OPCIONES.map((opcion) => (
            <Col span={8} key={opcion.key}>
              <Card
                hoverable={!opcion.disabled}
                onClick={() => this.seleccionar(opcion)}
                style={{
                  textAlign: "center",
                  height: 220,
                  opacity: opcion.disabled ? 0.55 : 1,
                  cursor: opcion.disabled ? "not-allowed" : "pointer",
                  borderTop: `3px solid ${opcion.color}`,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
                bodyStyle={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <div style={{ fontSize: 36, color: opcion.color, marginBottom: 10 }}>
                  {opcion.icono}
                </div>
                <h2 style={{ fontSize: 16, marginBottom: 6 }}>{opcion.titulo}</h2>
                {opcion.disabled && (
                  <Tag color="default" style={{ marginBottom: 6 }}>
                    Próximamente
                  </Tag>
                )}
                <p style={{ fontSize: 12, color: "#666", margin: 0 }}>
                  {opcion.descripcion}
                </p>
              </Card>
            </Col>
          ))}
        </Row>
      </>
    );
  }
}

export default ReporteCobranzaPorSemana;
